import Box from "@mui/material/Box";
import AcceptButton from "./AcceptButton";

export const getColumns = (t) => {
	return [
		{
			label: t("company_name_label"),
			name: "companyName",
		},
		{
			label: t("nip_label"),
			name: "nip",
		},
		{ label: t("when"), name: "changeDate" },
		{
			label: t("first_name_label"),
			name: "firstName",
			options: {
				display: false,
			},
		},
		{
			label: t("surname_label"),
			name: "lastName",
			options: {
				display: false,
			},
		},
		{
			label: t("user_name_and_surname"),
			name: "fullName",
			options: {
				customBodyRender: (value, tableMeta, updateValue) => {
					const rowData = tableMeta.rowData;
					const firstName = rowData[3];
					const lastName = rowData[4];

					return firstName + " " + lastName;
				},
			},
		},
		{
			label: t("action"),
			name: "changeType",
			options: {
				customBodyRender: (value, tableMeta, updateValue) => {
					return value === "removed" ? t("remove_action") : t("add_action");
				},
			},
		},
		{
			label: t("actions"),
			name: "id",
			options: {
				filter: false,
				sort: false,
				empty: true,
				customBodyRender: (value) => {
					return (
						<Box sx={{ display: "flex", justifyContent: "center" }}>
							<AcceptButton changeId={value} />
						</Box>
					);
				},
			},
		},
	];
};

export const getOptions = (t) => {
	return {
		searchOpen: true,
		search: false,
		searchAlwaysOpen: true,
		searchPlaceholder: t("search"),
		selectableRows: "none",
		print: false,
		filter: false,
		download: true,
		viewColumns: false,
		rowsPerPageOptions: [10, 20, 50, 100],
		rowsPerPage: 20,
		textLabels: {
			pagination: {
				next: t("next_page"),
				previous: t("previous_page"),
				rowsPerPage: t("rows_per_page"),
				displayRows: t("of"),
			},
			toolbar: {
				search: t("search"),
				downloadCsv: t("download_csv"),
				print: t("print"),
				viewColumns: t("select_columns"),
				filterTable: t("filters"),
			},
			filter: {
				title: t("filters"),
				reset: t("reset"),
				all: t("all"),
			},
			viewColumns: {
				title: t("show_columns"),
			},
			selectedRows: {
				text: t("removed_rows"),
				delete: t("remove"),
			},
			body: {
				noMatch: t("no_matching_data_found"),
			},
		},
	};
};
